export default "__VITE_ASSET__DmLQtKmG__"